import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import jsPDF from "jspdf";
import {
    formatTotalHours,
    getAllMonths, getAllYears, getFieldData, getMonthLastDay, getMonthName,
    getTotalDays, getTotalHours
} from "../../../services/appService";
import Moment from "react-moment";
import { useDispatch, useSelector } from "react-redux";
import { getTimeLogDuration, getTimeLogs, getTimeLogsLoading, loadTimeLogDuration, loadTimeLogs } from "../../store/timeLog";
import { deleteSubcontractorTimeLogInvDoc, deleteTimeLogInvDoc, getSubTimeLogInvDocDeleteStatus, getTimeLogInvDocDeleteStatus, getTimeLogInvoice, loadTimeLogInvoice } from "../../store/timeLogInvoice";
import { getAlert, getConfirmAlert } from "../../../services/appAlerts";
import InvoiceReview from "../../../components/OMCRegistry/InvoiceReview";
import InvoiceApd from "../../../components/OMCRegistry/InvoiceApd";
import CandidatePay from "../../../components/OMCRegistry/CandidatePay";
import AddEditNotes from "../../../components/OMCRegistry/AddEditNotes";
import AddNewTimeLog from "../../../components/OMCRegistry/AddNewTimeLog";
import useDocDownload from "../../hooks/useDocDownload";
import { de } from "date-fns/locale";

const TIME_LOG_STYLES = {
  card: {
    borderRadius: "22px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "linear-gradient(180deg, #ffffff 0%, #fbfdff 100%)",
    boxShadow: "0 14px 34px rgba(15, 23, 42, 0.05)",
    overflow: "hidden",
  },
  cardHeader: {
    padding: "20px 22px 16px 22px",
    borderBottom: "1px solid rgba(226, 232, 240, 1)",
    background: "linear-gradient(180deg, #ffffff 0%, #f8fbff 100%)",
  },
  titleRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "14px",
    flexWrap: "wrap",
  },
  titleWrap: {
    display: "inline-flex",
    alignItems: "center",
    gap: "12px",
    minWidth: 0,
  },
  titleIcon: {
    width: "38px",
    height: "38px",
    borderRadius: "12px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%)",
    color: "#1d4ed8",
    fontSize: "16px",
    border: "1px solid rgba(191, 219, 254, 1)",
  },
  title: {
    fontSize: "18px",
    fontWeight: 800,
    color: "#0f172a",
    marginBottom: "4px",
  },
  subtitle: {
    fontSize: "13px",
    lineHeight: 1.6,
    color: "#64748b",
    margin: 0,
  },
  primaryButton: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    borderRadius: "999px",
    border: "1px solid rgba(191, 219, 254, 1)",
    background: "#eff6ff",
    color: "#1d4ed8",
    padding: "8px 14px",
    fontSize: "12px",
    fontWeight: 700,
    outline: "none",
    cursor: "pointer",
  },
  cardBody: {
    padding: "18px 22px 22px 22px",
  },
  tableWrap: {
    border: "1px solid rgba(226, 232, 240, 1)",
    borderRadius: "18px",
    overflow: "auto",
    backgroundColor: "#ffffff",
  },
  table: {
    marginBottom: 0,
  },
  tableHeadCell: {
    borderTop: "none",
    fontSize: "12px",
    fontWeight: 800,
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    color: "#64748b",
    background: "#f8fafc",
    padding: "14px 16px",
    verticalAlign: "top",
  },
  tableHeadSubtext: {
    display: "block",
    fontSize: "10px",
    fontWeight: 700,
    letterSpacing: "0.04em",
    textTransform: "none",
    color: "#94a3b8",
    marginTop: "4px",
  },
  cell: {
    verticalAlign: "top",
    padding: "18px 16px",
    borderTop: "1px solid rgba(226, 232, 240, 0.75)",
    fontSize: "13px",
    color: "#0f172a",
  },
  chip: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "34px",
    padding: "0 12px",
    borderRadius: "999px",
    background: "linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%)",
    color: "#1d4ed8",
    fontSize: "13px",
    fontWeight: 800,
    border: "1px solid rgba(191, 219, 254, 1)",
    whiteSpace: "nowrap",
  },
  periodText: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    padding: "8px 12px",
    borderRadius: "14px",
    background: "linear-gradient(135deg, #f8fafc 0%, #eff6ff 100%)",
    border: "1px solid rgba(219, 234, 254, 1)",
    boxShadow: "inset 0 0 0 1px rgba(255, 255, 255, 0.7)",
    fontSize: "14px",
    fontWeight: 700,
    color: "#0f172a",
    marginBottom: "6px",
    cursor: "pointer",
    outline: "none",
  },
  periodIcon: {
    color: "#2563eb",
    fontSize: "13px",
  },
  metricButton: {
    display: "inline-flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "4px",
    padding: "8px 12px",
    borderRadius: "14px",
    background: "linear-gradient(135deg, #f8fafc 0%, #eff6ff 100%)",
    border: "1px solid rgba(219, 234, 254, 1)",
    boxShadow: "inset 0 0 0 1px rgba(255, 255, 255, 0.7)",
    color: "#0f172a",
    cursor: "pointer",
    textAlign: "left",
    outline: "none",
  },
  metricPrimary: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    fontSize: "14px",
    fontWeight: 800,
    lineHeight: 1.15,
    color: "#0f172a",
  },
  metricSecondary: {
    display: "block",
    color: "#64748b",
    fontSize: "14px",
    fontWeight: 800,
    lineHeight: 1.2,
  },
  statusStack: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "7px",
  },
  statusPill: {
    display: "inline-flex",
    alignItems: "center",
    gap: "7px",
    minHeight: "30px",
    padding: "6px 11px",
    borderRadius: "999px",
    border: "1px solid transparent",
    fontSize: "12px",
    fontWeight: 700,
    lineHeight: 1.2,
    whiteSpace: "nowrap",
  },
  statusPending: {
    color: "#92400e",
    backgroundColor: "#fffbeb",
    borderColor: "rgba(253, 230, 138, 1)",
  },
  statusApproved: {
    color: "#166534",
    backgroundColor: "#f0fdf4",
    borderColor: "rgba(187, 247, 208, 1)",
  },
  statusRejected: {
    color: "#991b1b",
    backgroundColor: "#fef2f2",
    borderColor: "rgba(254, 202, 202, 1)",
  },
  statusReviewed: {
    color: "#1d4ed8",
    backgroundColor: "#eff6ff",
    borderColor: "rgba(191, 219, 254, 1)",
  },
  statusDate: {
    fontSize: "12px",
    color: "#64748b",
    lineHeight: 1.4,
  },
  docList: {
    listStyle: "none",
    margin: 0,
    padding: 0,
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  docRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "10px",
    padding: "8px 10px",
    border: "1px solid rgba(226, 232, 240, 1)",
    borderRadius: "14px",
    background: "#ffffff",
    boxShadow: "0 6px 14px rgba(15, 23, 42, 0.03)",
  },
  docLink: {
    border: "none",
    background: "transparent",
    color: "#2563eb",
    padding: 0,
    fontSize: "13px",
    fontWeight: 700,
    textAlign: "left",
    wordBreak: "break-word",
    outline: "none",
    cursor: "pointer",
  },
  iconButton: {
    width: "30px",
    height: "30px",
    borderRadius: "999px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 0,
    boxShadow: "0 6px 14px rgba(15, 23, 42, 0.04)",
    cursor: "pointer",
    outline: "none",
  },
  notesButton: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    borderRadius: "999px",
    border: "1px solid rgba(191, 219, 254, 1)",
    background: "#eff6ff",
    color: "#1d4ed8",
    padding: "7px 12px",
    fontSize: "12px",
    fontWeight: 700,
    cursor: "pointer",
    outline: "none",
  },
  notesBadge: {
    minWidth: "20px",
    height: "20px",
    borderRadius: "999px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#ffffff",
    color: "#0f172a",
    fontSize: "11px",
    fontWeight: 800,
    padding: "0 6px",
  },
  actionLink: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    borderRadius: "999px",
    border: "1px solid rgba(191, 219, 254, 1)",
    background: "#eff6ff",
    color: "#1d4ed8",
    padding: "7px 12px",
    fontSize: "12px",
    fontWeight: 700,
    cursor: "pointer",
    outline: "none",
  },
  actionStack: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "8px",
  },
  paymentBlock: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
  },
  paymentDate: {
    fontSize: "13px",
    fontWeight: 700,
    color: "#0f172a",
  },
  paymentText: {
    fontSize: "12px",
    color: "#475569",
  },
  selectInput: {
    borderRadius: "8px",
    border: "1px solid rgba(226, 232, 240, 1)",
    padding: "6px 10px",
    fontSize: "13px",
    fontWeight: 600,
    color: "#334155",
    background: "#ffffff",
    outline: "none",
    height: "36px",
    minWidth: "120px",
  },
  utilityRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "12px",
    flexWrap: "wrap",
    marginBottom: "14px",
  },
  utilityPanel: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "14px",
    padding: "14px 16px",
    borderRadius: "18px",
    border: "1px solid rgba(191, 219, 254, 0.9)",
    background: "linear-gradient(180deg, #ffffff 0%, #f8fbff 100%)",
    boxShadow: "0 10px 24px rgba(37, 99, 235, 0.06)",
    width: "100%",
    flexWrap: "wrap",
  },
  utilityPanelTop: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    flex: 1,
    minWidth: 0,
  },
  utilityIcon: {
    width: "36px",
    height: "36px",
    borderRadius: "12px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%)",
    color: "#1d4ed8",
    border: "1px solid rgba(191, 219, 254, 1)",
    flexShrink: 0,
  },
  utilityCopy: {
    minWidth: 0,
    flex: 1,
  },
  utilityLabel: {
    fontSize: "11px",
    fontWeight: 800,
    color: "#64748b",
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    margin: 0,
  },
  utilityActions: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    flexWrap: "wrap",
  },
};

export default function Subcontractor(props) {
    const { candidate, ptype, entType, wfTask, allRates } = props;

    const [timeLogs, setTimeLogs] = useState([]);
    const [timeLogInvoices, setTimeLogInvoices] = useState([]);
    const [invType, setInvType] = useState("subcontractor");
    const [invRevShowHide, setInvRevShowHide] = useState(false);
    const [invAdpShowHide, setInvAdpShowHide] = useState(false);
    const [payShowHide, setPayShowHide] = useState(false);
    const [noteShowHide, setNoteShowHide] = useState(false);
    const [timeLogShowHide, setTimeLogShowHide] = useState(false);
    const [reportShowHide, setReportShowHide] = useState(false);
    const [reportPdfLoading, setReportPdfLoading] = useState(false);
    const [timeLogObj, setTimeLogObj] = useState("");
    const [reportTimeLogObj, setReportTimeLogObj] = useState(null);
    const [filterYear, setFilterYear] = useState("");
    const [filterMonth, setFilterMonth] = useState("");
    const [selectedYear, setSelectedYear] = useState("");
    const [selectedMonth, setSelectedMonth] = useState("");
    const [notesType, setNotesType] = useState("TimeLog");
    const [projectStartDate, setProjectStartDate] = useState("");
    const [projectStDt, setProjectStDt] = useState("");
    const [currentStDt, setCurrentStDt] = useState("");

    const [lastLoadedId, setLastLoadedId] = useState(null);
    const timeLogsSelector = useSelector(getTimeLogs);
    const isTimeLogsLoading = useSelector(getTimeLogsLoading);
    const timeLogsInvoiceSelector = useSelector(getTimeLogInvoice);
    const timeLogDurationSelector = useSelector(getTimeLogDuration);
    const timeLogInvDocDeleteStatusSelector = useSelector(getSubTimeLogInvDocDeleteStatus);

    const [handleDownloadFile] = useDocDownload();

    const dispatch = useDispatch();
    const sortTimeLogsByLatestPeriod = (logs = []) =>
        [...logs].sort((a, b) => {
            const yearDiff = (parseInt(b?.year, 10) || 0) - (parseInt(a?.year, 10) || 0);
            if (yearDiff !== 0) return yearDiff;

            return (parseInt(b?.month, 10) || 0) - (parseInt(a?.month, 10) || 0);
        });


    useEffect(() => {
        if (candidate?.id) {
            dispatch(loadTimeLogs(candidate.id));
            dispatch(loadTimeLogInvoice(candidate.id));
            dispatch(loadTimeLogDuration(candidate.id));
            setSelectedYear("");
            setSelectedMonth("");
            setFilterYear("");
            setFilterMonth("");
            setLastLoadedId(candidate.id);
        }
    }, [candidate?.id]);

    useEffect(() => {
        if (timeLogsInvoiceSelector.length > 0) {
            let type = invType;
            if (entType !== "C2C Basis")
                type = "candidate";
            const subcontractorInvoices = timeLogsInvoiceSelector.filter(x => x.invoiceType === type);
            setTimeLogInvoices(subcontractorInvoices)
        }

        if (timeLogDurationSelector?.startDate) {
            const startDate = new Date(timeLogDurationSelector.startDate);
            startDate.setDate(startDate.getDate()); // add 1 day
            const result = startDate.toISOString().substring(0, 10);
            setProjectStDt(startDate);
            setCurrentStDt(timeLogDurationSelector.projectStartedDate);
        }
    }, [timeLogsInvoiceSelector, timeLogDurationSelector]);

    useEffect(() => {
        let filterTimeLogs = [...timeLogsSelector];
        if (filterYear > 0)
            filterTimeLogs = filterTimeLogs.filter(x => x.year === parseInt(filterYear));

        if (filterMonth > 0)
            filterTimeLogs = filterTimeLogs.filter(x => x.month === parseInt(filterMonth));

        setTimeLogs(sortTimeLogsByLatestPeriod(filterTimeLogs));

    }, [timeLogsSelector, filterMonth, filterYear]);

    const handleApplyFilter = () => {
        setFilterYear(selectedYear);
        setFilterMonth(selectedMonth);
    };

    const handleResetFilter = () => {
        setSelectedYear("");
        setSelectedMonth("");
        setFilterYear("");
        setFilterMonth("");
    };

    const years = getAllYears();
    const months = getAllMonths();
    const perfData = candidate?.performerData;
    // let candidateRate = getFieldData(candidate.performerData, "candidateonboardingform", "Rate_hour_Paid_to_Candidate") ? getFieldData(candidate.performerData, "candidateonboardingform", "Rate_hour_Paid_to_Candidate") : "0.00"
    let candidateRate = candidate?.rates?.candidateRate ? candidate?.rates?.candidateRate : "0.00"
    let candidateDate = candidate?.rates?.candidateEffectiveDate;
    let subcontractorRate = candidate?.rates?.subcontractorRate;
    let subcontractorDate = candidate?.rates?.subcontractorEffectiveDate;

    if (entType === "C2C Basis") {
        candidateRate = subcontractorRate;
        candidateDate = subcontractorDate;
    }

    const w9Type = getFieldData(perfData, "candidateonboardingform", "w9_Type");
    const costBefenifit = getFieldData(perfData, "candidateonboardingform", "Cost_of_Benefit");

    const getApplicableRateDetails = (item) => {
        const itemYear = parseInt(item?.year, 10);
        const itemMonth = parseInt(item?.month, 10);
        const rateField = entType === "C2C Basis" ? "subcontractorRate" : "candidateRate";
        const dateField = entType === "C2C Basis" ? "subcontractorEffectiveDate" : "candidateEffectiveDate";
        const matchedRate = Array.isArray(allRates)
            ? allRates.reduce((best, rate, index) => {
                if (!itemYear || !itemMonth) return best;

                const effMs = new Date(rate?.[dateField]).getTime();
                if (Number.isNaN(effMs)) return best;

                const effDt = new Date(effMs);
                const effYear = effDt.getFullYear();
                const effMonth = effDt.getMonth() + 1;
                const isApplicable =
                    effYear < itemYear ||
                    (effYear === itemYear && effMonth <= itemMonth);

                if (!isApplicable) return best;
                if (!best) return { rate, index, effMs };

                if (effMs > best.effMs) return { rate, index, effMs };
                if (effMs < best.effMs) return best;

                const addedMs = new Date(rate?.addedDateTime).getTime();
                const bestAddedMs = new Date(best.rate?.addedDateTime).getTime();
                const safeAddedMs = Number.isNaN(addedMs) ? -Infinity : addedMs;
                const safeBestAddedMs = Number.isNaN(bestAddedMs) ? -Infinity : bestAddedMs;

                if (safeAddedMs > safeBestAddedMs) return { rate, index, effMs };
                if (safeAddedMs < safeBestAddedMs) return best;

                const idNum = Number(rate?.id);
                const bestIdNum = Number(best.rate?.id);
                const safeIdNum = Number.isFinite(idNum) ? idNum : -Infinity;
                const safeBestIdNum = Number.isFinite(bestIdNum) ? bestIdNum : -Infinity;

                if (safeIdNum > safeBestIdNum) return { rate, index, effMs };
                if (safeIdNum < safeBestIdNum) return best;

                return index > best.index ? { rate, index, effMs } : best;
            }, null)?.rate
            : null;
        const fallbackRate = 0;//parseFloat(candidateRate || 0);
        const rateValue =
            matchedRate?.[rateField] !== null &&
                matchedRate?.[rateField] !== undefined &&
                matchedRate?.[rateField] !== ""
                ? parseFloat(matchedRate[rateField])
                : fallbackRate;

        const effectiveDate = matchedRate?.[dateField] || "";
        return {
            rate: rateValue,
            effectiveDate,
        };
    };

    const getInvoiceAmount = (item) => {
        const totHrs = getTotalHours(item?.workingHrs || 0);
        const { rate: applicableRate } = getApplicableRateDetails(item);

        let invAmt = totHrs * applicableRate;

        // If not W2, return straight amount
        if (entType !== "W2 Basis") {
            return parseFloat(invAmt || 0).toFixed(2);
        }

        // W2 → add tax
        const taxRate = (getFieldData(perfData, "candidateonboardingform", "Tax") || 0) / 100;
        invAmt = invAmt + invAmt * taxRate;

        return parseFloat(invAmt || 0).toFixed(2);
    };

    const getFinalAmout = (obj) => {
        let fAmt = parseFloat(getInvoiceAmount(obj) || 0);

        const invItems = timeLogInvoices.filter(
            (x) => x.timeLogId === obj.id
        );

        if (invItems.length === 0) {
            return fAmt.toFixed(2);
        }

        const item = invItems[0];

        const adjMinus = parseFloat(item?.adjustmentMinues || 0);
        const adjPlus = parseFloat(item?.adjustmentPlus || 0);
        const adp = parseFloat(item?.adpDeduction || 0);

        // Apply adjustments
        fAmt = fAmt - adjMinus + adjPlus - adp;

        return fAmt.toFixed(2);
    };


    const getMonthlyPeriod = (obj) => {
        if (!obj?.workingHrs) return "";

        let wt;
        try {
            wt = JSON.parse(obj.workingHrs);
        } catch (e) {
            return "";
        }

        if (!Array.isArray(wt) || wt.length === 0) return "";

        const sortWt = [...wt].sort(
            (a, b) => new Date(a.start) - new Date(b.start)
        );

        const first = sortWt[0];
        const last = sortWt[sortWt.length - 1];

        const lastDate =
            last.type === "m"
                ? getMonthLastDay(last.start)
                : last.start;

        return (
            <span>
                <Moment format="MM/DD/YYYY">{first.start}</Moment>
                {" - "}
                <Moment format="MM/DD/YYYY">{lastDate}</Moment>
            </span>
        );
    };


    const getC2CInvoiceStatus = (item) => {
        const tmLogs = timeLogInvoices.filter(
            (x) => x.timeLogId === item.id
                && x.status !== null
        );
        if (tmLogs.length === 0) {
            return (
                <button
                    type="button"
                    className="wf-status-pill wf-status-pending"
                    style={{ cursor: "pointer", outline: "none" }}
                    onClick={() => handleInvRevShowHide(item)}
                >
                    <i className="fa fa-clock-o" aria-hidden="true"></i> Review
                </button>
            );
        }

        return (
            <div className="wf-status-stack">
                {tmLogs.map((inv, index) => (
                    <React.Fragment key={inv.id || index}>
                        <div style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}>
                            <button
                                type="button"
                                className="wf-status-pill wf-status-reviewed"
                                style={{ cursor: "pointer", outline: "none" }}
                                onClick={() => handleInvRevShowHide(item)}
                            >
                                <i className="fa fa-eye" aria-hidden="true"></i> Reviewed
                            </button>
                            {inv.status === true && (
                                <i className="fa fa-check-circle" style={{ color: "#10b981", fontSize: "16px" }} aria-hidden="true" title="Approved" />
                            )}
                            {inv.status === false && (
                                <i className="fa fa-times-circle" style={{ color: "#ef4444", fontSize: "16px" }} aria-hidden="true" title="Rejected" />
                            )}
                        </div>
                        {inv.reviewDateTime && (
                            <div style={{ display: "inline-flex", alignItems: "center", gap: "8px", marginTop: "4px" }}>
                                <div style={{
                                    display: "inline-flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    width: "20px",
                                    height: "20px",
                                    borderRadius: "5px",
                                    background: "#faf5ff",
                                    color: "#7c3aed",
                                    fontSize: "11px",
                                    flexShrink: 0
                                }}>
                                    <i className="fa fa-calendar-o" />
                                </div>
                                <span style={{
                                    fontSize: "13px",
                                    fontWeight: 600,
                                    color: "#475569",
                                    lineHeight: 1
                                }}>
                                    <Moment format="MMM Do YYYY, h:mm a">{inv.reviewDateTime}</Moment>
                                </span>
                            </div>
                        )}
                    </React.Fragment>
                ))}
            </div>
        );
    }

    const getInvoiceDeduction = (item) => {
        const tmLogs = timeLogInvoices.filter(
            (x) =>
                x.timeLogId === item.id
                && x.adpDeduction !== null
        );
        if (tmLogs.length === 0) {
            return (
                <button
                    type="button"
                    className="wf-status-pill wf-status-reviewed"
                    style={{ cursor: "pointer", outline: "none" }}
                    onClick={() => handleAdpShowHide(item)}
                >
                    <i className="fa fa-plus-circle" aria-hidden="true"></i> Add/Edit
                </button>
            );
        }

        return (
            <div className="wf-status-stack">
                {tmLogs.map((inv, index) => (
                    <React.Fragment key={inv.id || index}>
                        <button
                            type="button"
                            className="wf-status-pill wf-status-reviewed"
                            style={{ cursor: "pointer", outline: "none" }}
                            onClick={() => handleAdpShowHide(item)}
                        >
                            <i className="fa fa-pencil-square-o" aria-hidden="true"></i> View/Edit (${parseFloat(inv.adpDeduction || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })})
                        </button>
                        {inv.adpDateTime && (
                             <div style={{ display: "inline-flex", alignItems: "center", gap: "8px", marginTop: "4px" }}>
                                 <div style={{
                                     display: "inline-flex",
                                     alignItems: "center",
                                     justifyContent: "center",
                                     width: "20px",
                                     height: "20px",
                                     borderRadius: "5px",
                                     background: "#faf5ff",
                                     color: "#7c3aed",
                                     fontSize: "11px",
                                     flexShrink: 0
                                 }}>
                                     <i className="fa fa-calendar-o" />
                                 </div>
                                 <span style={{
                                     fontSize: "13px",
                                     fontWeight: 600,
                                     color: "#475569",
                                     lineHeight: 1
                                 }}>
                                     <Moment format="MMM Do YYYY, h:mm a">{inv.adpDateTime}</Moment>
                                 </span>
                             </div>
                        )}
                        {inv?.adpDocList && inv.adpDocList.length > 0 && (
                            <ul className="wf-doc-list" style={{ marginTop: "4px" }}>
                                {inv.adpDocList.map((doc, idx) => (
                                    <li key={idx} className="wf-doc-row">
                                        <button
                                            type="button"
                                            className="wf-doc-link"
                                            onClick={() => handleDownloadFile(doc.invDoc)}
                                            title={doc.documentName}
                                        >
                                            <i className="fa fa-paperclip" aria-hidden="true"></i> {doc.documentName.length > 15 ? doc.documentName.substring(0, 15) + "..." : doc.documentName}
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        )}
                    </React.Fragment>
                ))}
            </div>
        );
    }

    const getSubcontractorInvoice = (item) => {
        const tmLogs = timeLogInvoices
            .filter(
                (x) =>
                    x.timeLogId === item.id &&
                    x.invDoc !== null
            );

        if (tmLogs.length === 0) return <span style={{ color: "#94a3b8" }}>—</span>;

        return (
            <div className="wf-status-stack">
                {tmLogs.map((inv, index) => (
                    <React.Fragment key={inv.id || index}>
                        <span style={{ fontWeight: 700, fontSize: "13px", color: "#334155" }}>
                            Inv: {inv.invoiceNumber}
                        </span>
                        {inv.invDoc && (
                            <div className="wf-doc-row">
                                <button
                                    type="button"
                                    className="wf-doc-link"
                                    onClick={() => handleDownloadFile(inv.invDoc)}
                                    title={inv.invDoc.documentName}
                                >
                                    <i className="fa fa-file-pdf-o" style={{ color: "#ef4444", marginRight: "4px" }} />
                                    {inv.invDoc.documentName.length > 15 ? inv.invDoc.documentName.substring(0, 15) + "..." : inv.invDoc.documentName}
                                </button>
                            </div>
                        )}
                        {inv.notes === "delete" && (
                            <button
                                type="button"
                                style={{
                                    border: "none",
                                    background: "transparent",
                                    color: "#ef4444",
                                    padding: 0,
                                    fontSize: "11px",
                                    fontWeight: 700,
                                    cursor: "pointer",
                                    outline: "none",
                                    marginTop: "2px"
                                }}
                                title="Delete Invoice Document"
                                onClick={() => handleDeleteInvoiceDoc(inv.id)}
                            >
                                <i className="fa fa-trash-o" /> Delete/Regenerate
                            </button>
                        )}
                    </React.Fragment>
                ))}
            </div>
        );
    }

    const handleDeleteInvoiceDoc = async (id) => {
        const result = await getConfirmAlert("", "Are you sure you want to delete this document?", "error");
        if (result.isConfirmed) {
            dispatch(deleteSubcontractorTimeLogInvDoc(id))
        }
    }

    useEffect(() => {
        if (timeLogInvDocDeleteStatusSelector) {
            getAlert("", "Successfully Deleted.", "success");
            if (candidate?.id)
                dispatch(loadTimeLogInvoice(candidate.id));
        }
    }, [timeLogInvDocDeleteStatusSelector])

    const getPaymentStatus = (item) => {
        const tmLogs = timeLogInvoices.filter(
            (x) =>
                x.timeLogId === item.id &&
                x.paymentMode !== null
        );
        if (tmLogs.length === 0) {
            return (
                <button
                    type="button"
                    className="wf-status-pill wf-status-rejected"
                    style={{ cursor: "pointer", outline: "none" }}
                    onClick={() => handlePayShowHide(item)}
                >
                    <i className="fa fa-credit-card" aria-hidden="true"></i> To Pay
                </button>
            );
        }

        return (
            <div className="wf-status-stack">
                {tmLogs.map((pay, index) => (
                    <React.Fragment key={pay.id || index}>
                        <button
                            type="button"
                            className="wf-status-pill wf-status-approved"
                            style={{ cursor: "pointer", outline: "none" }}
                            onClick={() => handlePayShowHide(item)}
                        >
                            <i className="fa fa-check-circle" aria-hidden="true"></i> Paid By IPCS (${parseFloat(pay.paidAmount || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })})
                        </button>
                        {pay.paymentDate && (
                            <div style={{ display: "inline-flex", alignItems: "center", gap: "8px", marginTop: "4px" }}>
                                <div style={{
                                    display: "inline-flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    width: "20px",
                                    height: "20px",
                                    borderRadius: "5px",
                                    background: "#faf5ff",
                                    color: "#7c3aed",
                                    fontSize: "11px",
                                    flexShrink: 0
                                }}>
                                    <i className="fa fa-calendar-o" />
                                </div>
                                <span style={{
                                    fontSize: "13px",
                                    fontWeight: 600,
                                    color: "#475569",
                                    lineHeight: 1
                                }}>
                                    <Moment format="MMM Do YYYY">{pay.paymentDate}</Moment>
                                </span>
                            </div>
                        )}
                        {pay?.docList && pay.docList.length > 0 && (
                            <ul className="wf-doc-list" style={{ marginTop: "4px" }}>
                                {pay.docList.map((doc, idx) => (
                                    <li key={idx} className="wf-doc-row">
                                        <button
                                            type="button"
                                            className="wf-doc-link"
                                            onClick={() => handleDownloadFile(doc)}
                                            title={doc.documentName}
                                        >
                                            <i className="fa fa-paperclip" /> {doc.documentName.length > 15 ? doc.documentName.substring(0, 15) + "..." : doc.documentName}
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        )}
                    </React.Fragment>
                ))}
            </div>
        );
    }

    const getDueAmountStatus = (item) => {
        const tmLogs = timeLogInvoices
            .filter(
                (x) =>
                    x.timeLogId === item.id &&
                    x.paidAmount !== null
            );
        if (tmLogs.length === 0) return "";

        return (
            <>
                {tmLogs.map((inv) => parseFloat(getFinalAmout(item) - inv.paidAmount).toFixed(2))}
            </>
        );
    }

    const getPerDiemAmount = (item) => {
        const perDiem = getFieldData(
            perfData,
            "candidateonboardingform",
            "Per_Diem_Rate"
        );
        if (perDiem !== "") {
            const calculatedPerDiem = parseFloat(perDiem) * getTotalDays(item?.workingHrs || 0);
            return (
                <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: "4px" }}>
                    <div style={{
                        fontSize: "13.5px",
                        fontWeight: 800,
                        color: "#0f172a",
                        display: "inline-flex",
                        alignItems: "center"
                    }}>
                        ${parseFloat(perDiem).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                        <span style={{ color: "#64748b", fontSize: "11px", fontWeight: 600, textTransform: "uppercase", marginLeft: "4px" }}>/ day</span>
                    </div>
                    <div style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "6px",
                        fontSize: "12px",
                        fontWeight: 700,
                        color: "#1e293b",
                        background: "#eff6ff",
                        border: "1px solid #bfdbfe",
                        borderRadius: "6px",
                        padding: "3px 8px"
                    }}>
                        <span style={{ color: "#1e40af", fontSize: "11px", fontWeight: 700, textTransform: "uppercase" }}>Total:</span>
                        <span style={{ color: "#1d4ed8", fontWeight: 800 }}>
                            ${calculatedPerDiem.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                        </span>
                    </div>
                </div>
            );
        }

        return <span style={{ color: "#94a3b8" }}>—</span>;
    }

    const handleInvRevShowHide = (obj) => {
        if (obj === "save") {
            setInvRevShowHide(false);
            setTimeLogObj("");
            if (candidate?.id)
                dispatch(loadTimeLogInvoice(candidate?.id))
        }
        else {
            setInvRevShowHide(!invRevShowHide);
            setTimeLogObj(obj);
        }
    };

    const handleAdpShowHide = (obj) => {
        if (obj === "save") {
            setInvAdpShowHide(false);
            setTimeLogObj("");
            if (candidate?.id)
                dispatch(loadTimeLogInvoice(candidate?.id))
        } else {
            setInvAdpShowHide(!invAdpShowHide);
            setTimeLogObj(obj);
        }
    };

    const handlePayShowHide = async (obj) => {
        if (obj === "save") {
            setPayShowHide(false);
            setTimeLogObj("");
            if (candidate?.id)
                dispatch(loadTimeLogInvoice(candidate?.id))
        } else {
            if (obj === "close") {
                setPayShowHide(false);
                setTimeLogObj("");
            } else {
                const chkInvoice = timeLogInvoices.filter(
                    (x) =>
                        x.timeLogId === obj.id && x.invDoc !== null
                );
                if (chkInvoice.length > 0) {
                    setPayShowHide(!payShowHide);
                    setTimeLogObj(obj);
                } else if (entType === "C2C Basis") {
                    getAlert("", "Invoice not generated", "error");
                } else {
                    setPayShowHide(!payShowHide);
                    setTimeLogObj(obj);
                }
            }
        }
    };

    const handleShowHide = async (obj) => {
        if (obj === "save") {
            setTimeLogShowHide(false);
            setTimeLogObj("");
            if (candidate?.id)
                dispatch(loadTimeLogs(candidate.id));
        } else {
            setTimeLogShowHide(!timeLogShowHide);
            setTimeLogObj(obj);
        }
    };

    const handleNoteShowHide = (obj, type) => {
        if (obj === "save") {
            setNoteShowHide(false);
            setTimeLogObj("");
        } else {
            setNoteShowHide(!noteShowHide);
            setTimeLogObj(obj);
        }
    };

    const isTimeLogReportGenerated = (item) =>
        item?.status === true || item?.status === "true" || item?.status === 1;

    const formatCurrency = (value) =>
        `$${parseFloat(value || 0).toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        })}`;

    const getCandidateName = () =>
        [
            candidate?.performername || candidate?.performerName || candidate?.name,
            candidate?.lastName,
        ]
            .filter(Boolean)
            .join(" ") || "N/A";

    const getCandidateId = () =>
        candidate?.maxloans || candidate?.performerid || candidate?.id || "N/A";

    const getTimeLogReportDetails = (item) => {
        const { rate } = getApplicableRateDetails(item);
        const hours = Number(getTotalHours(item?.workingHrs) || 0);

        return {
            candidateId: getCandidateId(),
            candidateName: getCandidateName(),
            monthYear: item ? `${getMonthName(item.month)} ${item.year}` : "N/A",
            period: item ? getMonthlyPeriod(item) : "N/A",
            hours,
            hoursLabel: item ? formatTotalHours(item?.workingHrs) : "0h 0m",
            days: item ? getTotalDays(item?.workingHrs) : 0,
            rate: Number(rate || 0),
            totalCompensation: hours * Number(rate || 0),
            positionTitle:
                getFieldData(perfData, "projectengagement", "PositionTitle") || "N/A",
            agencyName:
                getFieldData(perfData, "projectengagement", "AgencyName") || "N/A",
        };
    };

    const handleReportShowHide = (item) => {
        if (!item) {
            setReportShowHide(false);
            setReportTimeLogObj(null);
            setReportPdfLoading(false);
            return;
        }

        setReportTimeLogObj(item);
        setReportShowHide(true);
    };

    const downloadReportTimeLogPdf = () => {
        if (!reportTimeLogObj || reportPdfLoading) return;

        setReportPdfLoading(true);
        const previewWindow = window.open("", "_blank");

        if (previewWindow) {
            previewWindow.document.write(
                "<html><head><title>Preparing PDF</title></head><body style='font-family:Arial,sans-serif;padding:24px;color:#334155;'>Preparing PDF preview...</body></html>"
            );
            previewWindow.document.close();
        }

        setTimeout(() => {
            try {
                const report = getTimeLogReportDetails(reportTimeLogObj);
                const doc = new jsPDF("portrait", "pt", "a4");
                const pageWidth = doc.internal.pageSize.getWidth();
                const pageHeight = doc.internal.pageSize.getHeight();
                const margin = 42;
                const contentWidth = pageWidth - margin * 2;

                doc.setFillColor(239, 246, 255);
                doc.setDrawColor(191, 219, 254);
                doc.roundedRect(margin, 40, contentWidth, 108, 14, 14, "FD");
                doc.setFillColor(37, 99, 235);
                doc.roundedRect(margin + 10, 54, 2, 80, 1, 1, "F");

                doc.setTextColor(15, 23, 42);
                doc.setFont("helvetica", "bold");
                doc.setFontSize(21);
                doc.text("Report Time Log", margin + 24, 78);

                doc.setFont("helvetica", "normal");
                doc.setFontSize(10.5);
                doc.setTextColor(71, 85, 105);
                doc.text("Generated monthly report preview", margin + 24, 102);
                doc.setFont("helvetica", "bold");
                doc.setFontSize(9);
                doc.text(`Generated: ${new Date().toLocaleDateString("en-US")}`, margin + 24, 126);

                doc.setFillColor(255, 255, 255);
                doc.setDrawColor(219, 234, 254);
                const statusPillX = pageWidth - margin - 118;
                const statusPillY = 64;
                const statusPillW = 88;
                const statusPillH = 34;
                const statusText = "GENERATED";
                doc.roundedRect(statusPillX, statusPillY, statusPillW, statusPillH, 17, 17, "FD");
                doc.setTextColor(37, 99, 235);
                doc.setFont("helvetica", "bold");
                doc.setFontSize(9);
                doc.text(
                    statusText,
                    statusPillX + (statusPillW - doc.getTextWidth(statusText)) / 2,
                    statusPillY + 21
                );

                const detailCards = [
                    ["Candidate", report.candidateName],
                    ["Candidate ID", report.candidateId.toString()],
                    ["Position", report.positionTitle],
                    ["Agency", report.agencyName],
                ];

                const detailCardW = (contentWidth - 14) / 2;
                const detailCardH = 62;
                const detailStartY = 174;
                detailCards.forEach(([label, value], index) => {
                    const cardX = margin + (index % 2) * (detailCardW + 14);
                    const cardY = detailStartY + Math.floor(index / 2) * (detailCardH + 14);
                    doc.setFillColor(248, 250, 252);
                    doc.setDrawColor(226, 232, 240);
                    doc.roundedRect(cardX, cardY, detailCardW, detailCardH, 10, 10, "FD");
                    doc.setTextColor(100, 116, 139);
                    doc.setFont("helvetica", "bold");
                    doc.setFontSize(8);
                    doc.text(label.toUpperCase(), cardX + 16, cardY + 21);
                    doc.setTextColor(15, 23, 42);
                    doc.setFontSize(12);
                    doc.text(doc.splitTextToSize(value || "N/A", detailCardW - 32), cardX + 16, cardY + 43);
                });

                doc.setFillColor(255, 255, 255);
                doc.setDrawColor(226, 232, 240);
                doc.roundedRect(margin, 342, contentWidth, 244, 14, 14, "FD");

                doc.setTextColor(15, 23, 42);
                doc.setFont("helvetica", "bold");
                doc.setFontSize(16);
                doc.text(`${entType === "1099 Basis" ? "1099" : "W2"} - Time Log Reporting`, margin + 20, 374);

                doc.setTextColor(100, 116, 139);
                doc.setFont("helvetica", "normal");
                doc.setFontSize(10);
                doc.text(`Selected month time log report for ${report.monthYear}.`, margin + 20, 394);

                const reportCards = [
                    ["Month / Year", report.monthYear, [37, 99, 235], "Calendar period"],
                    ["Approved Hours", report.hoursLabel, [14, 116, 144], "Logged and approved by client"],
                    ["Rate / Hour", formatCurrency(report.rate), [124, 58, 237], "Applicable hourly rate"],
                    ["Total Compensation", formatCurrency(report.totalCompensation), [22, 101, 52], "Less applicable Taxes"],
                ];

                const reportCardW = (contentWidth - 54) / 2;
                const reportCardH = 68;
                const reportStartY = 420;
                reportCards.forEach(([label, value, color, hint], index) => {
                    const reportCardX = margin + 20 + (index % 2) * (reportCardW + 14);
                    const reportCardY = reportStartY + Math.floor(index / 2) * (reportCardH + 16);
                    doc.setFillColor(248, 250, 252);
                    doc.setDrawColor(226, 232, 240);
                    doc.roundedRect(reportCardX, reportCardY, reportCardW, reportCardH, 10, 10, "FD");
                    doc.setFillColor(color[0], color[1], color[2]);
                    doc.roundedRect(reportCardX + 8, reportCardY + 10, 2, reportCardH - 20, 1, 1, "F");
                    doc.setTextColor(100, 116, 139);
                    doc.setFont("helvetica", "bold");
                    doc.setFontSize(8);
                    doc.text(label.toUpperCase(), reportCardX + 17, reportCardY + 20);
                    doc.setTextColor(15, 23, 42);
                    doc.setFontSize(16);
                    doc.text(value, reportCardX + 17, reportCardY + 43);
                    doc.setTextColor(100, 116, 139);
                    doc.setFont("helvetica", "normal");
                    doc.setFontSize(8);
                    doc.text(hint, reportCardX + 17, reportCardY + 58);
                });

                doc.setDrawColor(226, 232, 240);
                doc.line(margin, pageHeight - 76, pageWidth - margin, pageHeight - 76);
                doc.setTextColor(100, 116, 139);
                doc.setFont("helvetica", "normal");
                doc.setFontSize(9);
                doc.text("This report is generated from submitted monthly time log data.", margin, pageHeight - 52);
                doc.text("IPCS Workbench", pageWidth - margin - 78, pageHeight - 52);

                const blobUrl = doc.output("bloburl");
                if (previewWindow) {
                    previewWindow.location.href = blobUrl;
                } else {
                    window.open(blobUrl, "_blank");
                }
            } finally {
                setReportPdfLoading(false);
            }
        }, 150);
    };

    // Computations for Stats Header
    const totalMinutes = timeLogs.reduce((sum, log) => {
        if (!log?.workingHrs) return sum;
        let wt;
        try {
            wt = JSON.parse(log.workingHrs);
        } catch (e) {
            return sum;
        }
        if (!Array.isArray(wt)) return sum;
        let logMinutes = 0;
        wt.filter((x) => x.title !== null).forEach((t) => {
            const parts = t.title.toString().split(".");
            const hours = parseInt(parts[0], 10) || 0;
            const minutes = parseInt(parts[1], 10) || 0;
            logMinutes += hours * 60 + minutes;
        });
        return sum + logMinutes;
    }, 0);

    const statHours = Math.floor(totalMinutes / 60);
    const statMinutes = totalMinutes % 60;
    const totalHoursStr = `${statHours}h ${statMinutes}m`;

    const totalDaysVal = timeLogs.reduce((sum, log) => sum + getTotalDays(log?.workingHrs), 0);

    const reviewedLogsCount = timeLogs.filter(log =>
        timeLogInvoices.some(inv => inv.timeLogId === log.id && inv.status !== null)
    ).length;

    const paidLogsCount = timeLogs.filter(log =>
        timeLogInvoices.some(inv => inv.timeLogId === log.id && (inv.paymentMode !== null || (inv.paidAmount !== null && parseFloat(inv.paidAmount) > 0)))
    ).length;

    const reviewedPaidStr = `${reviewedLogsCount} / ${paidLogsCount}`;

    return (
        <React.Fragment>
            <style>{`

                /* Modern Table Style matching WorkflowUser */
                .wf-table {
                  width: 100% !important;
                  border-collapse: separate !important;
                  border-spacing: 0 2px !important;
                }

                .wf-table-scroll {
                  overflow: auto !important;
                  scrollbar-width: thin;
                  scrollbar-color: #94a3b8 #f1f5f9;
                  border-radius: 12px;
                  border: 1px solid #cbd5e1 !important;
                  background-color: #ffffff;
                }

                .wf-table-scroll::-webkit-scrollbar {
                  width: 8px;
                  height: 8px;
                }

                .wf-table-scroll::-webkit-scrollbar-track {
                  background: #f1f5f9;
                  border-radius: 999px;
                }

                .wf-table-scroll::-webkit-scrollbar-thumb {
                  background: linear-gradient(180deg, #cbd5e1 0%, #94a3b8 100%);
                  border-radius: 999px;
                  border: 2px solid #f1f5f9;
                }

                .wf-table-scroll::-webkit-scrollbar-thumb:hover {
                  background: linear-gradient(180deg, #94a3b8 0%, #64748b 100%);
                }

                .wf-thead {
                  background: linear-gradient(90deg, #f8fafc 0%, #f1f5f9 100%) !important;
                  position: sticky !important;
                  top: 0 !important;
                  z-index: 2 !important;
                }

                .wf-thead th {
                  font-size: 11.5px !important;
                  font-weight: 700 !important;
                  color: #475569 !important;
                  text-transform: uppercase !important;
                  letter-spacing: 0.6px !important;
                  padding: 13px 16px !important;
                  border-bottom: 2px solid #e2e8f0 !important;
                  border-top: none !important;
                  white-space: nowrap !important;
                }

                .wf-table-row {
                  cursor: pointer !important;
                  transition: background 0.15s ease, box-shadow 0.15s ease, transform 0.1s ease !important;
                }

                .wf-table-row:hover {
                  background: linear-gradient(90deg, rgba(37,99,235,0.04) 0%, rgba(37,99,235,0.015) 100%) !important;
                  box-shadow: inset 3px 0 0 0 rgba(37,99,235,0.35) !important;
                }

                .wf-table-row:hover td {
                  color: #1e293b !important;
                }

                .wf-table-row:active {
                  transform: scaleY(0.98) !important;
                }

                .wf-table td {
                  padding: 13px 16px !important;
                  font-size: 13.5px !important;
                  color: #334155 !important;
                  border-bottom: 1px solid #f1f5f9 !important;
                  vertical-align: top !important;
                  transition: color 0.15s ease !important;
                }

                .wf-table tbody tr:last-child td {
                  border-bottom: none !important;
                }

                .wf-thead-subtext {
                  display: block !important;
                  font-size: 9.5px !important;
                  font-weight: 600 !important;
                  letter-spacing: 0.4px !important;
                  text-transform: none !important;
                  color: #64748b !important;
                  margin-top: 4px !important;
                }

                /* Premium Stats Header Row styling */
                .wf-stats-row {
                  display: grid;
                  grid-template-columns: repeat(4, 1fr);
                  gap: 16px;
                  margin-bottom: 24px;
                }

                @media (max-width: 992px) {
                  .wf-stats-row {
                    grid-template-columns: repeat(2, 1fr);
                  }
                }

                @media (max-width: 576px) {
                  .wf-stats-row {
                    grid-template-columns: 1fr;
                  }
                }

                .wf-stat-card {
                  background: linear-gradient(180deg, #ffffff 0%, #fcfdfe 100%);
                  border: 1px solid rgba(226, 232, 240, 0.9);
                  border-radius: 16px;
                  padding: 20px 22px;
                  box-shadow: 0 10px 30px -10px rgba(15, 23, 42, 0.04), 0 1px 3px rgba(15, 23, 42, 0.02);
                  display: flex;
                  flex-direction: column;
                  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
                  position: relative;
                  overflow: hidden;
                }

                .wf-stat-card:hover {
                  transform: translateY(-3px);
                  box-shadow: 0 20px 35px -15px rgba(37, 99, 235, 0.12), 0 4px 6px -4px rgba(37, 99, 235, 0.08);
                  border-color: rgba(37, 99, 235, 0.25);
                }

                .wf-stat-card::before {
                  content: "";
                  position: absolute;
                  top: 0;
                  left: 0;
                  right: 0;
                  height: 3px;
                  background: linear-gradient(90deg, #2563eb, #3b82f6);
                  opacity: 0;
                  transition: opacity 0.25s ease;
                }

                .wf-stat-card:hover::before {
                  opacity: 1;
                }

                .wf-stat-header-row {
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  margin-bottom: 12px;
                }

                .wf-stat-label {
                  font-size: 11px;
                  font-weight: 700;
                  text-transform: uppercase;
                  color: #64748b;
                  letter-spacing: 0.08em;
                  margin: 0;
                }

                .wf-stat-icon-wrap {
                  width: 32px;
                  height: 32px;
                  border-radius: 10px;
                  background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
                  color: #2563eb;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  font-size: 14px;
                  border: 1px solid rgba(191, 219, 254, 0.5);
                }

                .wf-stat-value {
                  font-size: 26px;
                  font-weight: 800;
                  color: #0f172a;
                  margin-bottom: 6px;
                  letter-spacing: -0.02em;
                  line-height: 1.15;
                }

                .wf-stat-hint {
                  font-size: 11.5px;
                  color: #64748b;
                  line-height: 1.5;
                  margin-top: auto;
                }

                /* Premium Controls Card */
                .wf-controls-card {
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  gap: 16px;
                  background: linear-gradient(180deg, #ffffff 0%, #fbfdff 100%);
                  border: 1px solid rgba(226, 232, 240, 0.9);
                  border-radius: 16px;
                  padding: 16px 24px;
                  margin-bottom: 24px;
                  box-shadow: 0 10px 30px -10px rgba(15, 23, 42, 0.04), 0 1px 3px rgba(15, 23, 42, 0.02);
                }

                @media (max-width: 576px) {
                  .wf-controls-card {
                    flex-direction: column;
                    align-items: stretch;
                    gap: 14px;
                    padding: 16px;
                  }
                }

                .wf-controls-left {
                  display: flex;
                  align-items: center;
                  gap: 16px;
                  flex-wrap: wrap;
                }

                @media (max-width: 576px) {
                  .wf-controls-left {
                    flex-direction: column;
                    align-items: stretch;
                    gap: 12px;
                  }
                }

                /* Select wrapper with prepended icon */
                .wf-select-wrapper {
                  position: relative;
                  display: inline-flex;
                  align-items: center;
                }

                @media (max-width: 576px) {
                  .wf-select-wrapper {
                    width: 100%;
                  }
                }

                .wf-select-icon {
                  position: absolute;
                  left: 14px;
                  color: #64748b;
                  font-size: 13.5px;
                  pointer-events: none;
                  z-index: 2;
                }

                .wf-control-select {
                  height: 38px;
                  min-width: 150px;
                  border-radius: 10px !important;
                  border: 1.5px solid #e2e8f0 !important;
                  padding: 0 36px 0 36px !important;
                  font-size: 13.5px !important;
                  font-weight: 600 !important;
                  color: #334155 !important;
                  background: #ffffff url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6'%3E%3Cpath d='M0 0l5 6 5-6z' fill='%2394a3b8'/%3E%3C/svg%3E") no-repeat right 14px center !important;
                  appearance: none !important;
                  -webkit-appearance: none !important;
                  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
                  cursor: pointer;
                  outline: none !important;
                }

                @media (max-width: 576px) {
                  .wf-control-select {
                    width: 100%;
                  }
                }

                .wf-control-select:hover {
                  border-color: #cbd5e1 !important;
                  background-color: #fafbfc !important;
                }

                .wf-control-select:focus {
                  border-color: #2563eb !important;
                  box-shadow: 0 0 0 3.5px rgba(37, 99, 235, 0.08) !important;
                  background-color: #ffffff !important;
                }

                 .wf-btn-add {
                   display: inline-flex;
                   align-items: center;
                   justify-content: center;
                   gap: 8px;
                   height: 38px;
                   padding: 0 18px;
                   border-radius: 10px;
                   border: 1px solid rgba(37, 99, 235, 0.15);
                   background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
                   color: #ffffff;
                   font-size: 13.5px;
                   font-weight: 700;
                   cursor: pointer;
                   transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
                   outline: none;
                   box-shadow: 0 4px 12px rgba(37, 99, 235, 0.15);
                 }

                 .wf-btn-add i {
                   font-size: 12px;
                   color: #ffffff;
                   font-weight: bold;
                 }

                 .wf-btn-add:hover {
                   background: linear-gradient(135deg, #1d4ed8 0%, #1e40af 100%);
                   border-color: rgba(37, 99, 235, 0.3);
                   color: #ffffff;
                   transform: translateY(-1px);
                   box-shadow: 0 6px 16px rgba(37, 99, 235, 0.2);
                 }

                 .wf-btn-add:active {
                   transform: scale(0.97);
                 }

                .wf-btn-apply {
                  display: inline-flex;
                  align-items: center;
                  justify-content: center;
                  gap: 8px;
                  height: 38px;
                  padding: 0 18px;
                  border-radius: 10px;
                  border: 1px solid rgba(37, 99, 235, 0.15);
                  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
                  color: #ffffff;
                  font-size: 13.5px;
                  font-weight: 700;
                  cursor: pointer;
                  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
                  outline: none;
                  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.15);
                }

                .wf-btn-apply i {
                  font-size: 12px;
                  color: #ffffff;
                  font-weight: bold;
                }

                .wf-btn-apply:hover {
                  background: linear-gradient(135deg, #1d4ed8 0%, #1e40af 100%);
                  transform: translateY(-1px);
                  box-shadow: 0 6px 16px rgba(37, 99, 235, 0.2);
                }

                .wf-btn-apply:active {
                  transform: scale(0.97);
                }

                .wf-btn-reset {
                  display: inline-flex;
                  align-items: center;
                  justify-content: center;
                  gap: 8px;
                  height: 38px;
                  padding: 0 18px;
                  border-radius: 10px;
                  border: 1px solid #cbd5e1;
                  background: #ffffff;
                  color: #475569;
                  font-size: 13.5px;
                  font-weight: 600;
                  cursor: pointer;
                  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
                  outline: none;
                }

                .wf-btn-reset i {
                  font-size: 12px;
                  color: #475569;
                }

                .wf-btn-reset:hover {
                  background: #f8fafc;
                  border-color: #94a3b8;
                  color: #1e293b;
                }

                 .wf-btn-reset:active {
                   transform: scale(0.97);
                 }

                 .wf-period-btn {
                   display: inline-flex;
                   align-items: center;
                   gap: 8px;
                   padding: 8px 14px;
                   border-radius: 12px;
                   background: linear-gradient(135deg, #f8fafc 0%, #eff6ff 100%);
                   border: 1px solid rgba(191, 219, 254, 0.8);
                   font-size: 13px;
                   font-weight: 700;
                   color: #0f172a;
                   cursor: pointer;
                   transition: all 0.2s ease;
                   outline: none;
                   box-shadow: 0 2px 4px rgba(15, 23, 42, 0.02);
                 }
                 .wf-period-btn:hover {
                   background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
                   border-color: rgba(37, 99, 235, 0.25);
                   transform: translateY(-1px);
                   box-shadow: 0 4px 8px rgba(37, 99, 235, 0.05);
                 }
                 .wf-period-btn:active {
                   transform: scale(0.97);
                 }
                 .wf-period-icon {
                   color: #2563eb;
                   font-size: 12.5px;
                 }

                 .wf-metric-btn {
                   display: inline-flex;
                   flex-direction: column;
                   align-items: flex-start;
                   gap: 4px;
                   padding: 8px 14px;
                   border-radius: 12px;
                   background: linear-gradient(135deg, #f8fafc 0%, #eff6ff 100%);
                   border: 1px solid rgba(191, 219, 254, 0.8);
                   color: #0f172a;
                   cursor: pointer;
                   transition: all 0.2s ease;
                   outline: none;
                   box-shadow: 0 2px 4px rgba(15, 23, 42, 0.02);
                 }
                 .wf-metric-btn:hover {
                   background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
                   border-color: rgba(37, 99, 235, 0.25);
                   transform: translateY(-1px);
                   box-shadow: 0 4px 8px rgba(37, 99, 235, 0.05);
                 }
                 .wf-metric-btn:active {
                   transform: scale(0.97);
                 }
                 .wf-metric-primary {
                   display: inline-flex;
                   align-items: center;
                   gap: 6px;
                   font-size: 13.5px;
                   font-weight: 800;
                   line-height: 1.15;
                   color: #0f172a;
                 }
                 .wf-metric-primary i {
                   color: #2563eb;
                   font-size: 12px;
                 }
                 .wf-metric-secondary {
                   display: block;
                   color: #64748b;
                   font-size: 11px;
                   font-weight: 700;
                   text-transform: uppercase;
                   letter-spacing: 0.5px;
                   line-height: 1.2;
                 }

                 .wf-notes-btn {
                   display: inline-flex;
                   align-items: center;
                   justify-content: center;
                   gap: 8px;
                   border-radius: 999px;
                   border: 1px solid rgba(191, 219, 254, 0.8);
                   background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
                   color: #1d4ed8;
                   padding: 7px 14px;
                   font-size: 12px;
                   font-weight: 700;
                   cursor: pointer;
                   transition: all 0.2s ease;
                   outline: none;
                 }
                 .wf-notes-btn:hover {
                   background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%);
                   border-color: rgba(37, 99, 235, 0.3);
                   transform: translateY(-1px);
                 }
                 .wf-notes-btn:active {
                   transform: scale(0.97);
                 }
                 .wf-notes-badge {
                   min-width: 18px;
                   height: 18px;
                   border-radius: 999px;
                   display: inline-flex;
                   align-items: center;
                   justify-content: center;
                   background: #ffffff;
                   color: #1d4ed8;
                   font-size: 10px;
                   font-weight: 800;
                   padding: 0 4px;
                   border: 1px solid rgba(191, 219, 254, 0.5);
                   margin-left: 4px;
                 }

                 .wf-doc-list {
                   list-style: none;
                   margin: 0;
                   padding: 0;
                   display: flex;
                   flex-direction: column;
                   gap: 6px;
                 }
                 .wf-doc-row {
                   display: flex;
                   justify-content: space-between;
                   align-items: center;
                   gap: 8px;
                   padding: 6px 10px;
                   border: 1px solid #e2e8f0;
                   border-radius: 10px;
                   background: #ffffff;
                   box-shadow: 0 2px 6px rgba(15, 23, 42, 0.015);
                   transition: all 0.2s ease;
                 }
                 .wf-doc-row:hover {
                   border-color: #cbd5e1;
                   background: #f8fafc;
                   transform: translateY(-0.5px);
                 }
                 .wf-doc-link {
                   border: none;
                   background: transparent;
                   color: #2563eb;
                   padding: 0;
                   font-size: 12px;
                   font-weight: 700;
                   text-align: left;
                   word-break: break-all;
                   outline: none;
                   cursor: pointer;
                   display: inline-flex;
                   align-items: center;
                   gap: 6px;
                 }
                 .wf-doc-link i {
                   color: #64748b;
                 }

                 .wf-status-stack {
                   display: flex;
                   flex-direction: column;
                   align-items: flex-start;
                   gap: 6px;
                 }
                 .wf-status-pill {
                   display: inline-flex;
                   align-items: center;
                   gap: 6px;
                   min-height: 28px;
                   padding: 4px 10px;
                   border-radius: 999px;
                   border: 1px solid transparent;
                   font-size: 11.5px;
                   font-weight: 700;
                   line-height: 1.2;
                   white-space: nowrap;
                   transition: all 0.2s ease;
                 }
                 .wf-status-pending {
                   color: #92400e;
                   background-color: #fffbeb;
                   border-color: #fde68a;
                 }
                 .wf-status-pending:hover {
                   background-color: #fef3c7;
                   border-color: #fcd34d;
                 }
                 .wf-status-approved {
                   color: #166534;
                   background-color: #f0fdf4;
                   border-color: #bbf7d0;
                 }
                 .wf-status-approved:hover {
                   background-color: #dcfce7;
                   border-color: #86efac;
                 }
                 .wf-status-rejected {
                   color: #991b1b;
                   background-color: #fef2f2;
                   border-color: #fecaca;
                 }
                 .wf-status-rejected:hover {
                   background-color: #fee2e2;
                   border-color: #fca5a5;
                 }
                 .wf-status-reviewed {
                   color: #1d4ed8;
                   background-color: #eff6ff;
                   border-color: #dbeafe;
                 }
                 .wf-status-reviewed:hover {
                   background-color: #dbeafe;
                   border-color: #bfdbfe;
                 }
                 .wf-status-date {
                   font-size: 11px;
                   color: #64748b;
                   line-height: 1.4;
                 }
             `}</style>

            <div className="subcontractor-dashboard">
                <div className="wf-controls-card">
                    <div className="wf-controls-left">
                        <div className="wf-select-wrapper">
                            <i className="fa fa-calendar wf-select-icon"></i>
                            <select
                                name="filterYear"
                                id="year"
                                className="wf-control-select"
                                aria-label="Select Year"
                                value={selectedYear}
                                onChange={({ currentTarget }) => setSelectedYear(currentTarget.value)}
                            >
                                <option value="">Year</option>
                                {years.map((y) => (
                                    <option key={y.name} value={y.name}>{y.name}</option>
                                ))}
                            </select>
                        </div>
                        <div className="wf-select-wrapper">
                            <i className="fa fa-filter wf-select-icon"></i>
                            <select
                                name="filterMonth"
                                id="month"
                                className="wf-control-select"
                                aria-label="Select Month"
                                value={selectedMonth}
                                onChange={({ currentTarget }) => setSelectedMonth(currentTarget.value)}
                            >
                                <option value="">Month</option>
                                {months.map((m) => (
                                    <option key={m.id} value={m.id}>{m.name}</option>
                                ))}
                            </select>
                        </div>
                        <button
                            type="button"
                            onClick={handleApplyFilter}
                            className="wf-btn-apply"
                        >
                            <i className="fa fa-search"></i> Apply Filter
                        </button>
                        <button
                            type="button"
                            onClick={handleResetFilter}
                            className="wf-btn-reset"
                        >
                            <i className="fa fa-refresh"></i> Reset
                        </button>
                    </div>
                    <div className="wf-controls-right">
                        <button
                            type="button"
                            onClick={() => handleShowHide("")}
                            className="wf-btn-add"
                        >
                            <i className="fa fa-plus"></i> Add
                        </button>
                    </div>
                </div>

                <div className="wf-stats-row">
                    <div className="wf-stat-card">
                        <div className="wf-stat-header-row">
                            <span className="wf-stat-label">Time Logs</span>
                            <div className="wf-stat-icon-wrap">
                                <i className="fa fa-file-text-o"></i>
                            </div>
                        </div>
                        <div className="wf-stat-value">{timeLogs.length}</div>
                        <div className="wf-stat-hint">Submitted time log periods currently available.</div>
                    </div>
                    <div className="wf-stat-card">
                        <div className="wf-stat-header-row">
                            <span className="wf-stat-label">Total Hours</span>
                            <div className="wf-stat-icon-wrap">
                                <i className="fa fa-clock-o"></i>
                            </div>
                        </div>
                        <div className="wf-stat-value">{totalHoursStr}</div>
                        <div className="wf-stat-hint">Combined hours logged across all visible periods.</div>
                    </div>
                    <div className="wf-stat-card">
                        <div className="wf-stat-header-row">
                            <span className="wf-stat-label">Total Days</span>
                            <div className="wf-stat-icon-wrap">
                                <i className="fa fa-calendar-check-o"></i>
                            </div>
                        </div>
                        <div className="wf-stat-value">{totalDaysVal}</div>
                        <div className="wf-stat-hint">Working days recorded from submitted time logs.</div>
                    </div>
                    <div className="wf-stat-card">
                        <div className="wf-stat-header-row">
                            <span className="wf-stat-label">Reviewed / Paid</span>
                            <div className="wf-stat-icon-wrap">
                                <i className="fa fa-credit-card"></i>
                            </div>
                        </div>
                        <div className="wf-stat-value">{reviewedPaidStr}</div>
                        <div className="wf-stat-hint">Periods reviewed by IPCS and periods with payment activity.</div>
                    </div>
                </div>

                <div className="table-responsive mt-2 wf-table-scroll">
                    <table className="table align-items-center table-flush table-striped wf-table">
                        <thead className="wf-thead">
                            <tr>
                                <th>Year</th>
                                <th>Month</th>
                                <th>
                                    Period
                                    <span className="wf-thead-subtext">Time Logged</span>
                                </th>
                                <th>
                                    Hours
                                    <span className="wf-thead-subtext">Days</span>
                                </th>
                                <th>
                                    Approved
                                    <span className="wf-thead-subtext">Timesheets</span>
                                </th>
                                {entType !== "W2 Basis" && <th>Status</th>}
                                {ptype !== "timelog" && <th>Rate/Hr</th>}
                                {ptype !== "timelog" && (
                                    <th>
                                        {entType === "C2C Basis" ? "Invoice" : "Gross Pay"}
                                        <span className="wf-thead-subtext">Amount ($)</span>
                                    </th>
                                )}
                                {w9Type === "W2 Hourly with Benefits" && (
                                    <th>Cost of benefit</th>
                                )}
                                {entType === "W2 Basis" && (
                                    <React.Fragment>
                                        <th>Deductions</th>
                                        <th>
                                            Net Pay
                                            <span className="wf-thead-subtext">Amount ($)</span>
                                        </th>
                                        <th>
                                            Per Diem Rate ($)
                                            <span className="wf-thead-subtext">Per Diem Amount ($)</span>
                                        </th>
                                    </React.Fragment>
                                )}
                                {entType === "C2C Basis" && ptype !== "timelog" && (
                                    <th>Invoice</th>
                                )}
                                <th>Notes</th>
                                {ptype !== "timelog" && (
                                    <>
                                        {entType !== "W2 Basis" && (
                                            <th>
                                                Net Pay
                                                <span className="wf-thead-subtext">Amount ($)</span>
                                            </th>
                                        )}
                                        <th>Payment</th>
                                    </>
                                )}
                                {entType !== "C2C Basis" && (
                                     <th>Report Time Log</th>
                                 )}
                            </tr>
                        </thead>
                        <tbody>
                            {(isTimeLogsLoading || lastLoadedId !== candidate?.id) ? (
                                <tr>
                                    <td colSpan={16} style={{ textAlign: "center", padding: "40px 20px", color: "#64748b" }}>
                                        <div style={{ fontSize: "28px", marginBottom: "10px", color: "#2563eb" }}>
                                            <i className="fa fa-spinner fa-spin"></i>
                                        </div>
                                        <div style={{ fontWeight: 600, fontSize: "15px" }}>Loading Time Logs...</div>
                                        <div style={{ fontSize: "13px", color: "#94a3b8", marginTop: "4px" }}>Please wait while we fetch the latest records.</div>
                                    </td>
                                </tr>
                            ) : timeLogs.length === 0 ? (
                                <tr>
                                    <td colSpan={16} style={{ textAlign: "center", padding: "40px 20px", color: "#64748b" }}>
                                        <div style={{ fontSize: "24px", marginBottom: "10px" }}><i className="fa fa-folder-open-o"></i></div>
                                        <div style={{ fontWeight: 600, fontSize: "15px" }}>No Time Logs Found</div>
                                        <div style={{ fontSize: "13px", color: "#94a3b8", marginTop: "4px" }}>There are no time logs available for the selected filters.</div>
                                    </td>
                                </tr>
                            ) : (
                                timeLogs.map((item) => (
                                    <tr key={item.id} className="wf-table-row">
                                        <td>
                                            <span style={{ fontWeight: 700, color: "#1e293b" }}>{item.year}</span>
                                        </td>
                                        <td>
                                            <span style={{ fontWeight: 600, color: "#334155" }}>{getMonthName(item.month)}</span>
                                        </td>
                                        <td>
                                            <button
                                                type="button"
                                                className="wf-period-btn"
                                                onClick={() => handleShowHide(item, "calendar")}
                                            >
                                                <i className="fa fa-calendar-o wf-period-icon" aria-hidden="true"></i>
                                                <span>{getMonthlyPeriod(item)}</span>
                                            </button>
                                        </td>
                                        <td>
                                            <button
                                                type="button"
                                                className="wf-metric-btn"
                                                onClick={() => handleShowHide(item, "calendar")}
                                            >
                                                <span className="wf-metric-primary">
                                                    <i className="fa fa-clock-o" aria-hidden="true"></i>
                                                    {formatTotalHours(item?.workingHrs)}
                                                </span>
                                                <span className="wf-metric-secondary">
                                                    {getTotalDays(item.workingHrs)}{" "}
                                                    {getTotalDays(item.workingHrs) > 1 ? "Days" : "Day"}
                                                </span>
                                            </button>
                                        </td>
                                        <td>
                                            {item.docList && item.docList.length > 0 ? (
                                                <ul className="wf-doc-list">
                                                    {item.docList.map((doc, idx) => (
                                                        <li key={idx} className="wf-doc-row">
                                                            <button
                                                                type="button"
                                                                className="wf-doc-link"
                                                                onClick={() => handleDownloadFile(doc)}
                                                                title={doc.documentName}
                                                            >
                                                                <i className="fa fa-paperclip" aria-hidden="true"></i>
                                                                {doc.documentName.length > 15
                                                                    ? doc.documentName.substring(0, 15) + "..."
                                                                    : doc.documentName}
                                                            </button>
                                                        </li>
                                                    ))}
                                                </ul>
                                            ) : (
                                                <span style={{ color: "#94a3b8" }}>—</span>
                                            )}
                                        </td>
                                        {entType !== "W2 Basis" && (
                                            <td>
                                                {getC2CInvoiceStatus(item)}
                                            </td>
                                        )}
                                        {ptype !== "timelog" && (
                                            <td>
                                                {(() => {
                                                    const { rate, effectiveDate } = getApplicableRateDetails(item);
                                                    return (
                                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: "4px" }}>
                                                            <div style={{
                                                                fontSize: "13.5px",
                                                                fontWeight: 800,
                                                                color: "#0f172a",
                                                                display: "inline-flex",
                                                                alignItems: "center"
                                                            }}>
                                                                ${parseFloat(rate || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                <span style={{ color: "#64748b", fontSize: "11px", fontWeight: 600, textTransform: "uppercase", marginLeft: "4px" }}>/ hr</span>
                                                            </div>
                                                            {effectiveDate && (
                                                                <div style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}>
                                                                    <span style={{ fontSize: "11.5px", fontWeight: 700, color: "#64748b" }}>Eff:</span>
                                                                    <div style={{
                                                                        display: "inline-flex",
                                                                        alignItems: "center",
                                                                        justifyContent: "center",
                                                                        width: "16px",
                                                                        height: "16px",
                                                                        borderRadius: "4px",
                                                                        background: "#faf5ff",
                                                                        color: "#7c3aed",
                                                                        fontSize: "9px",
                                                                        flexShrink: 0
                                                                    }}>
                                                                        <i className="fa fa-calendar-o" />
                                                                    </div>
                                                                    <span style={{
                                                                        fontSize: "12px",
                                                                        fontWeight: 600,
                                                                        color: "#475569"
                                                                    }}>
                                                                        <Moment format="MMM Do YYYY">{effectiveDate}</Moment>
                                                                    </span>
                                                                </div>
                                                            )}
                                                        </div>
                                                    );
                                                })()}
                                            </td>
                                        )}
                                        {ptype !== "timelog" && (
                                            <td>
                                                <div style={{
                                                    display: "inline-flex",
                                                    alignItems: "center",
                                                    fontSize: "13.5px",
                                                    fontWeight: 800,
                                                    color: "#1e293b",
                                                    background: "#f1f5f9",
                                                    border: "1px solid #e2e8f0",
                                                    borderRadius: "6px",
                                                    padding: "4px 8px"
                                                }}>
                                                    ${parseFloat(getInvoiceAmount(item) || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                </div>
                                            </td>
                                        )}
                                        {w9Type === "W2 Hourly with Benefits" && (
                                            <td>
                                                <div style={{
                                                    display: "inline-flex",
                                                    alignItems: "center",
                                                    fontSize: "13.5px",
                                                    fontWeight: 800,
                                                    color: "#be123c",
                                                    background: "#fff1f2",
                                                    border: "1px solid #ffe4e6",
                                                    borderRadius: "6px",
                                                    padding: "4px 8px"
                                                }}>
                                                    ${parseFloat(costBefenifit || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                </div>
                                            </td>
                                        )}
                                        {entType === "W2 Basis" && (
                                            <React.Fragment>
                                                <td>
                                                    {getInvoiceDeduction(item)}
                                                </td>
                                                <td>
                                                    <div style={{
                                                        display: "inline-flex",
                                                        alignItems: "center",
                                                        fontSize: "13.5px",
                                                        fontWeight: 800,
                                                        color: "#15803d",
                                                        background: "#f0fdf4",
                                                        border: "1px solid #bbf7d0",
                                                        borderRadius: "6px",
                                                        padding: "4px 8px"
                                                    }}>
                                                        ${parseFloat(getFinalAmout(item) || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                    </div>
                                                </td>
                                                <td>
                                                    {getPerDiemAmount(item)}
                                                </td>
                                            </React.Fragment>
                                        )}
                                        {entType === "C2C Basis" && ptype !== "timelog" && (
                                            <td>
                                                {getSubcontractorInvoice(item)}
                                            </td>
                                        )}
                                        <td>
                                            <button
                                                type="button"
                                                className="wf-notes-btn"
                                                onClick={() => handleNoteShowHide(item, "TimeLog")}
                                            >
                                                <i className="fa fa-commenting-o" aria-hidden="true"></i>
                                                View/Add
                                                <span className="wf-notes-badge">
                                                    {item?.allComments.filter(x => x.commentType === notesType).length}
                                                </span>
                                            </button>
                                        </td>
                                        {ptype !== "timelog" && (
                                            <>
                                                {entType !== "W2 Basis" && (
                                                    <td>
                                                        <div style={{
                                                            display: "inline-flex",
                                                            alignItems: "center",
                                                            fontSize: "13.5px",
                                                            fontWeight: 800,
                                                            color: "#15803d",
                                                            background: "#f0fdf4",
                                                            border: "1px solid #bbf7d0",
                                                            borderRadius: "6px",
                                                            padding: "4px 8px"
                                                        }}>
                                                            ${parseFloat(getFinalAmout(item) || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                        </div>
                                                    </td>
                                                )}
                                                <td>
                                                    {getPaymentStatus(item)}
                                                </td>
                                            </>
                                        )}
                                        {entType !== "C2C Basis" && (
                                             <td>
                                                 {isTimeLogReportGenerated(item) ? (
                                                     <button
                                                         type="button"
                                                         className="wf-status-pill wf-status-approved"
                                                         style={{ cursor: "pointer", outline: "none" }}
                                                         onClick={() => handleReportShowHide(item)}
                                                         title="View generated time log report"
                                                     >
                                                         <i className="fa fa-eye" aria-hidden="true"></i>
                                                         Generated
                                                     </button>
                                                 ) : (
                                                     <span className="wf-status-pill wf-status-pending">
                                                         <i className="fa fa-clock-o" aria-hidden="true"></i>
                                                         Pending
                                                     </span>
                                                 )}
                                             </td>
                                         )}
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            <Modal
                show={reportShowHide}
                onHide={() => handleReportShowHide(null)}
                size="xl"
                dialogClassName="rt-tools-modal rt-time-log-report-modal theme-primary"
                centered
            >
                <style>{`
                    .modal-backdrop {
                        z-index: 1080 !important;
                    }
                    .modal {
                        z-index: 1090 !important;
                    }
                    .modal-backdrop.show {
                        backdrop-filter: blur(8px) !important;
                        -webkit-backdrop-filter: blur(8px) !important;
                        background-color: rgba(15, 23, 42, 0.45) !important;
                        opacity: 1 !important;
                    }
                    .modal.fade .rt-tools-modal.modal-dialog {
                        transform: scale(0.95) !important;
                        transition: transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1) !important;
                    }
                    .modal.show .rt-tools-modal.modal-dialog {
                        transform: scale(1) !important;
                    }
                    .rt-time-log-report-modal {
                        --task-accent: #3b82f6;
                        --task-soft: #eff6ff;
                        max-width: 90% !important;
                        width: 1180px !important;
                    }
                    .rt-time-log-report-modal .modal-content {
                        border-radius: 12px !important;
                        box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25) !important;
                        overflow: hidden !important;
                        background: #ffffff !important;
                    }
                    .rt-time-log-report-modal .modal-header {
                        position: relative !important;
                        display: block !important;
                        padding: 24px 28px 20px 32px !important;
                        background: linear-gradient(90deg, var(--task-soft) 0%, rgba(255,255,255,0.98) 54%, #ffffff 100%) !important;
                        border-bottom: 1px solid #edf2f7 !important;
                        overflow: hidden !important;
                    }
                    .rt-time-log-report-modal .modal-header::before {
                        content: "" !important;
                        position: absolute !important;
                        top: 0 !important;
                        left: 0 !important;
                        bottom: 0 !important;
                        width: 4px !important;
                        background: var(--task-accent) !important;
                    }
                    .rt-report-header-shell {
                        display: flex !important;
                        flex-direction: column !important;
                        gap: 14px !important;
                        width: 100% !important;
                    }
                    .rt-report-header-top {
                        display: flex !important;
                        justify-content: space-between !important;
                        align-items: flex-start !important;
                        gap: 18px !important;
                        width: 100% !important;
                    }
                    .rt-report-header-main {
                        display: flex !important;
                        align-items: center !important;
                        gap: 14px !important;
                        min-width: 0 !important;
                    }
                    .rt-report-header-icon {
                        width: 52px !important;
                        height: 52px !important;
                        border-radius: 10px !important;
                        display: inline-flex !important;
                        align-items: center !important;
                        justify-content: center !important;
                        color: var(--task-accent) !important;
                        background: #ffffff !important;
                        border: 1px solid var(--task-accent) !important;
                        box-shadow: 0 8px 18px -12px rgba(15,23,42,0.28) !important;
                        font-size: 15px !important;
                        flex-shrink: 0 !important;
                    }
                    .rt-report-title {
                        margin: 0 !important;
                        color: #0f172a !important;
                        font-size: 18px !important;
                        font-weight: 850 !important;
                        line-height: 1.2 !important;
                    }
                    .rt-report-title-badge {
                        display: inline-flex !important;
                        align-items: center !important;
                        justify-content: center !important;
                        margin-left: 12px !important;
                        padding: 4px 10px !important;
                        border-radius: 999px !important;
                        font-size: 10px !important;
                        font-weight: 800 !important;
                        text-transform: uppercase !important;
                        letter-spacing: 0.02em !important;
                        background: #f0fdf4 !important;
                        color: #166534 !important;
                        border: 1px solid #bbf7d0 !important;
                    }
                    .rt-report-meta-row {
                        display: flex !important;
                        align-items: center !important;
                        flex-wrap: wrap !important;
                        gap: 10px 12px !important;
                        margin-top: 8px !important;
                        font-size: 12px !important;
                        color: #64748b !important;
                    }
                    .rt-report-meta-chip {
                        display: inline-flex !important;
                        align-items: center !important;
                        gap: 6px !important;
                        background: #ffffff !important;
                        padding: 5px 10px !important;
                        border-radius: 8px !important;
                        font-weight: 700 !important;
                        color: #475569 !important;
                        border: 1px solid #e2e8f0 !important;
                        box-shadow: 0 1px 3px rgba(15,23,42,0.04) !important;
                    }
                    .rt-report-meta-chip i {
                        color: var(--task-accent) !important;
                        font-size: 11px !important;
                    }
                    .rt-report-close-btn {
                        display: inline-flex !important;
                        align-items: center !important;
                        justify-content: center !important;
                        width: 40px !important;
                        height: 40px !important;
                        color: #64748b !important;
                        background: #ffffff !important;
                        border: 1px solid #cbd5e1 !important;
                        border-radius: 8px !important;
                        cursor: pointer !important;
                        transition: all 0.2s ease !important;
                        box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05) !important;
                    }
                    .rt-report-close-btn:hover {
                        color: #0f172a !important;
                        border-color: #94a3b8 !important;
                        background: #f8fafc !important;
                        transform: translateY(-1px) !important;
                    }
                    .rt-time-log-report-modal .modal-body {
                        padding: 24px !important;
                        background: #ffffff !important;
                        max-height: calc(100vh - 180px) !important;
                        overflow-y: auto !important;
                    }
                    .rt-report-summary-grid {
                        display: grid !important;
                        grid-template-columns: repeat(auto-fit, minmax(180px, 1fr)) !important;
                        gap: 12px !important;
                        margin-bottom: 18px !important;
                    }
                    .rt-report-summary-card {
                        border: 1px solid #e2e8f0 !important;
                        border-radius: 10px !important;
                        padding: 14px !important;
                        background: #ffffff !important;
                        box-shadow: 0 1px 3px rgba(15,23,42,0.04) !important;
                    }
                    .rt-report-summary-label {
                        margin-bottom: 6px !important;
                        color: #64748b !important;
                        font-size: 10px !important;
                        font-weight: 800 !important;
                        letter-spacing: 0.06em !important;
                        text-transform: uppercase !important;
                    }
                    .rt-report-summary-value {
                        color: #0f172a !important;
                        font-size: 14px !important;
                        font-weight: 800 !important;
                        line-height: 1.35 !important;
                    }
                    .rt-report-preview-card {
                        border: 1px solid #e2e8f0 !important;
                        border-radius: 12px !important;
                        overflow: hidden !important;
                        background: #ffffff !important;
                        box-shadow: 0 1px 3px rgba(15,23,42,0.04) !important;
                    }
                    .rt-report-preview-head {
                        padding: 16px 18px !important;
                        background: #f8fafc !important;
                        border-bottom: 1px solid #e2e8f0 !important;
                    }
                    .rt-report-preview-title {
                        margin: 0 !important;
                        color: #0f172a !important;
                        font-size: 15px !important;
                        font-weight: 850 !important;
                    }
                    .rt-report-preview-subtitle {
                        margin: 5px 0 0 !important;
                        color: #64748b !important;
                        font-size: 12px !important;
                    }
                    .rt-report-metric-grid {
                        display: grid !important;
                        grid-template-columns: repeat(4, minmax(0, 1fr)) !important;
                        gap: 12px !important;
                        padding: 18px !important;
                    }
                    @media (max-width: 992px) {
                        .rt-report-metric-grid {
                            grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
                        }
                    }
                    @media (max-width: 576px) {
                        .rt-report-metric-grid {
                            grid-template-columns: 1fr !important;
                        }
                    }
                    .rt-report-metric-card {
                        position: relative !important;
                        min-height: 112px !important;
                        border: 1px solid #e2e8f0 !important;
                        border-radius: 12px !important;
                        background: linear-gradient(180deg, #ffffff 0%, #fbfdff 100%) !important;
                        padding: 16px 16px 14px 16px !important;
                        overflow: hidden !important;
                        box-shadow: 0 10px 22px -18px rgba(15, 23, 42, 0.35) !important;
                    }
                    .rt-report-metric-card::before {
                        content: "" !important;
                        position: absolute !important;
                        top: 0 !important;
                        left: 0 !important;
                        right: 0 !important;
                        height: 4px !important;
                        background: var(--metric-accent, #2563eb) !important;
                    }
                    .rt-report-metric-icon {
                        width: 34px !important;
                        height: 34px !important;
                        border-radius: 10px !important;
                        display: inline-flex !important;
                        align-items: center !important;
                        justify-content: center !important;
                        color: var(--metric-accent, #2563eb) !important;
                        background: var(--metric-soft, #eff6ff) !important;
                        border: 1px solid #e2e8f0 !important;
                        margin-bottom: 12px !important;
                    }
                    .rt-report-metric-label {
                        margin-bottom: 6px !important;
                        color: #64748b !important;
                        font-size: 10px !important;
                        font-weight: 850 !important;
                        letter-spacing: 0.07em !important;
                        text-transform: uppercase !important;
                    }
                    .rt-report-metric-value {
                        color: #0f172a !important;
                        font-size: 20px !important;
                        font-weight: 850 !important;
                        line-height: 1.15 !important;
                        word-break: break-word !important;
                    }
                    .rt-report-muted {
                        display: block !important;
                        color: #64748b !important;
                        font-size: 11px !important;
                        margin-top: 4px !important;
                    }
                    .rt-time-log-report-modal .modal-footer {
                        background: #f8fafc !important;
                        border-top: 1px solid #edf2f7 !important;
                        padding: 16px 24px !important;
                        display: flex !important;
                        justify-content: flex-end !important;
                        gap: 10px !important;
                    }
                    .rt-report-download-btn,
                    .rt-report-footer-close-btn {
                        display: inline-flex !important;
                        align-items: center !important;
                        gap: 7px !important;
                        padding: 9px 18px !important;
                        font-size: 13px !important;
                        font-weight: 800 !important;
                        border-radius: 8px !important;
                        outline: none !important;
                        cursor: pointer !important;
                        transition: all 0.2s ease !important;
                    }
                    .rt-report-download-btn {
                        color: #ffffff !important;
                        background: #2563eb !important;
                        border: 1px solid #2563eb !important;
                        box-shadow: 0 10px 18px rgba(37, 99, 235, 0.18) !important;
                    }
                    .rt-report-download-btn:disabled {
                        opacity: 0.72 !important;
                        cursor: not-allowed !important;
                        transform: none !important;
                        box-shadow: none !important;
                    }
                    .rt-report-footer-close-btn {
                        color: #475569 !important;
                        background: #ffffff !important;
                        border: 1px solid #cbd5e1 !important;
                    }
                `}</style>
                {reportTimeLogObj && (() => {
                    const report = getTimeLogReportDetails(reportTimeLogObj);

                    return (
                        <>
                            <Modal.Header>
                                <div className="rt-report-header-shell">
                                    <div className="rt-report-header-top">
                                        <div className="rt-report-header-main">
                                            <i className="rt-report-header-icon fa fa-file-text-o" aria-hidden="true" />
                                            <div>
                                                <h2 className="rt-report-title">
                                                    Report Time Log
                                                    <span className="rt-report-title-badge">Generated</span>
                                                </h2>
                                                <div className="rt-report-meta-row">
                                                    <span className="rt-report-meta-chip">
                                                        <i className="fa fa-user" aria-hidden="true" /> {report.candidateName}
                                                    </span>
                                                    <span className="rt-report-meta-chip">
                                                        <i className="fa fa-calendar" aria-hidden="true" /> {report.monthYear}
                                                    </span>
                                                    <span className="rt-report-meta-chip">
                                                        <i className="fa fa-clock-o" aria-hidden="true" /> {report.hoursLabel}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <button
                                            type="button"
                                            className="rt-report-close-btn"
                                            onClick={() => handleReportShowHide(null)}
                                            title="Close report"
                                        >
                                            <i className="fa fa-times" aria-hidden="true" />
                                        </button>
                                    </div>
                                </div>
                            </Modal.Header>
                            <Modal.Body>
                                <div className="rt-report-summary-grid">
                                    <div className="rt-report-summary-card">
                                        <div className="rt-report-summary-label">Candidate</div>
                                        <div className="rt-report-summary-value">{report.candidateName}</div>
                                    </div>
                                    <div className="rt-report-summary-card">
                                        <div className="rt-report-summary-label">Candidate ID</div>
                                        <div className="rt-report-summary-value">{report.candidateId}</div>
                                    </div>
                                    <div className="rt-report-summary-card">
                                        <div className="rt-report-summary-label">Position</div>
                                        <div className="rt-report-summary-value">{report.positionTitle}</div>
                                    </div>
                                    <div className="rt-report-summary-card">
                                        <div className="rt-report-summary-label">Agency</div>
                                        <div className="rt-report-summary-value">{report.agencyName}</div>
                                    </div>
                                </div>

                                <div className="rt-report-preview-card">
                                    <div className="rt-report-preview-head">
                                        <h3 className="rt-report-preview-title">
                                            {entType === "1099 Basis" ? "1099" : "W2"} - Time Log Reporting
                                        </h3>
                                        <p className="rt-report-preview-subtitle">
                                            Selected month time log report for {report.monthYear}.
                                        </p>
                                    </div>
                                    <div className="rt-report-metric-grid">
                                        <div
                                            className="rt-report-metric-card"
                                            style={{
                                                "--metric-accent": "#2563eb",
                                                "--metric-soft": "#eff6ff",
                                            }}
                                        >
                                            <span className="rt-report-metric-icon">
                                                <i className="fa fa-calendar" aria-hidden="true"></i>
                                            </span>
                                            <div className="rt-report-metric-label">Month / Year</div>
                                            <div className="rt-report-metric-value">{report.monthYear}</div>
                                        </div>
                                        <div
                                            className="rt-report-metric-card"
                                            style={{
                                                "--metric-accent": "#0e7490",
                                                "--metric-soft": "#ecfeff",
                                            }}
                                        >
                                            <span className="rt-report-metric-icon">
                                                <i className="fa fa-clock-o" aria-hidden="true"></i>
                                            </span>
                                            <div className="rt-report-metric-label">Approved Hours</div>
                                            <div className="rt-report-metric-value">{report.hoursLabel}</div>
                                            <span className="rt-report-muted">Logged and approved by client</span>
                                        </div>
                                        <div
                                            className="rt-report-metric-card"
                                            style={{
                                                "--metric-accent": "#7c3aed",
                                                "--metric-soft": "#f5f3ff",
                                            }}
                                        >
                                            <span className="rt-report-metric-icon">
                                                <i className="fa fa-usd" aria-hidden="true"></i>
                                            </span>
                                            <div className="rt-report-metric-label">Rate / Hour</div>
                                            <div className="rt-report-metric-value">{formatCurrency(report.rate)}</div>
                                        </div>
                                        <div
                                            className="rt-report-metric-card"
                                            style={{
                                                "--metric-accent": "#166534",
                                                "--metric-soft": "#f0fdf4",
                                            }}
                                        >
                                            <span className="rt-report-metric-icon">
                                                <i className="fa fa-line-chart" aria-hidden="true"></i>
                                            </span>
                                            <div className="rt-report-metric-label">Total Compensation</div>
                                            <div className="rt-report-metric-value">{formatCurrency(report.totalCompensation)}</div>
                                            <span className="rt-report-muted">Less applicable Taxes</span>
                                        </div>
                                    </div>
                                </div>
                            </Modal.Body>
                            <Modal.Footer>
                                <button
                                    type="button"
                                    className="rt-report-download-btn"
                                    onClick={downloadReportTimeLogPdf}
                                    disabled={reportPdfLoading}
                                >
                                    <i
                                        className={`fa ${
                                            reportPdfLoading
                                                ? "fa-spinner fa-spin"
                                                : "fa-external-link"
                                        }`}
                                        aria-hidden="true"
                                    />
                                    {reportPdfLoading ? "Preparing PDF..." : "Preview PDF"}
                                </button>
                                <button
                                    type="button"
                                    className="rt-report-footer-close-btn"
                                    onClick={() => handleReportShowHide(null)}
                                >
                                    <i className="fa fa-times" aria-hidden="true" />
                                    Close
                                </button>
                            </Modal.Footer>
                        </>
                    );
                })()}
            </Modal>

            <InvoiceReview
                invRevShowHide={invRevShowHide}
                handleInvRevShowHide={handleInvRevShowHide}
                candidateObj={candidate}
                selectedObj={timeLogObj}
                invType={invType}
                timeLogInvoices={timeLogInvoices}
                getInvoiceAmount={getInvoiceAmount}
                entType={entType}
            ></InvoiceReview>

            <InvoiceApd
                handleAdpShowHide={handleAdpShowHide}
                invAdpShowHide={invAdpShowHide}
                candidateObj={candidate}
                selectedObj={timeLogObj}
                invType={invType}
                timeLogInvoices={timeLogInvoices}
                getInvoiceAmount={getInvoiceAmount}
                entType={entType}
            ></InvoiceApd>

            <CandidatePay
                payShowHide={payShowHide}
                handlePayShowHide={handlePayShowHide}
                candidateObj={candidate}
                selectedObj={timeLogObj}
                invType={invType}
                timeLogInvoices={timeLogInvoices}
                getInvoiceAmount={getInvoiceAmount}
                entType={entType}
                wfTask={wfTask}
            ></CandidatePay>

            {noteShowHide &&
                <AddEditNotes
                    noteShowHide={noteShowHide}
                    handleNoteShowHide={handleNoteShowHide}
                    notesType={notesType}
                    candidateObj={candidate}
                    timeLogObj={timeLogObj}
                ></AddEditNotes>}
            {
                timeLogShowHide &&
                <AddNewTimeLog
                    showHide={timeLogShowHide}
                    handleShowHide={handleShowHide}
                    selectedObj={timeLogObj}
                    allTimeLogs={timeLogs}
                    candidateObj={candidate}
                    timeLogInvoices={timeLogInvoices}
                    projectStartDate={projectStDt}
                ></AddNewTimeLog>
            }

        </React.Fragment>
    )
}
